import { render, staticRenderFns } from "./ElDescriptionItem.vue?vue&type=template&id=e3d60668&scoped=true"
import script from "./ElDescriptionItem.vue?vue&type=script&lang=js"
export * from "./ElDescriptionItem.vue?vue&type=script&lang=js"
import style0 from "./ElDescriptionItem.vue?vue&type=style&index=0&id=e3d60668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d60668",
  null
  
)

export default component.exports